import classNames from "classnames";
import { useContext, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { ProfileContext } from "../../../features/Profile/context";
import { useAccess, useAccessInList } from "../../../utils/hooks/access";
import { useMainCompany } from "../../../utils/hooks/company";
import Button from "../../Button";

const notesPermissions = ["people.manageNote", "people.manageAllNotes"];

function Topbar({ menu, setMenu }) {
	const { t } = useTranslation();

	const { isSelf } = useContext(ProfileContext);

	const { hasAccess: canManageDocuments } = useAccess(
		isSelf ? "profile.manageDocuments" : "people.manageDocuments",
	);
	const { hasAccess: canManageNotes } = useAccessInList(notesPermissions);
	const { hasAccess: canViewTimeoff } = useAccess(
		isSelf ? "profile.timeOff.canView" : "people.timeOff.canView",
	);
	const { hasAccess: canViewExpectedHours } = useAccess(
		isSelf ? "profile.expectedHours.canView" : "people.expectedHours.canView",
	);
	const { hasAccess: canViewWorkingShift } = useAccess(
		isSelf ? "profile.workingShift.canView" : "people.workingShift.canView"
	)
	const { hasAccess: canViewHistory } = useAccess(
		isSelf ? "profile.viewHistory" : "people.viewHistory"
	);
	const { hasAccess: canViewPBJ } = useAccess(
		isSelf ? "profile.pbjCode.canView" : "people.pbjCode.canView"
	);
	const company = useMainCompany();
	const modules = useMemo(() => {
		return company?.settings?.modules || [];
	}, [company?.settings?.modules]);

	return (
		<div className="d-flex flex-wrap text-center w-100 h-unset mb-3">
			<Button
				className={classNames(
					"text-primary px-3 p-2 btn-round mb-2 mb-md-2 shadow-lg mx-1 small-radius border",
					menu === "job-pay" && "bg-primary text-white",
				)}
				onClick={() => setMenu("job-pay")}
			>
				{t("job-and-pay")}
			</Button>

			<Button
				className={classNames(
					"text-primary px-3 p-2 btn-round mb-2 mb-md-2 shadow-lg mx-1 small-radius border ",
					menu === "personal" && "bg-primary text-white",
				)}
				onClick={() => setMenu("personal")}
			>
				{t("personal")}
			</Button>

			{canViewTimeoff && (
				<Button
					className={classNames(
						"text-primary px-3 p-2 btn-round mb-2 mb-md-2 shadow-lg mx-1 small-radius border ",
						menu === "time-off" && "bg-primary text-white",
					)}
					onClick={() => setMenu("time-off")}
				>
					{t("time-off")}
				</Button>
			)}

			{canViewPBJ && modules.includes("pbj") && (
				<Button
					className={classNames(
						"text-primary px-3 p-2 btn-round mb-2 mb-md-2 shadow-lg mx-1 small-radius border ",
						menu === "pbj" && "bg-primary text-white",
					)}
					onClick={() => setMenu("pbj")}
				>
					{t("PBJ")}
				</Button>
			)}

			{canViewExpectedHours && (
				<Button
					className={classNames(
						"text-primary px-3 p-2 btn-round mb-2 mb-md-2 shadow-lg mx-1 small-radius border ",
						menu === "expected-hours" && "bg-primary text-white",
					)}
					onClick={() => setMenu("expected-hours")}
				>
					{t("expected-hours")}
				</Button>
			)}

			{canManageDocuments && (
				<Button
					className={classNames(
						"text-primary px-3 p-2 btn-round mb-2 mb-md-2 shadow-lg mx-1 small-radius border ",
						menu === "documents" && "bg-primary text-white",
					)}
					onClick={() => setMenu("documents")}
				>
					{t("documents")}
				</Button>
			)}

			{!isSelf && canManageNotes && (
				<Button
					className={classNames(
						"text-primary px-3 p-2 btn-round mb-2 mb-md-2 shadow-lg mx-1 small-radius border ",
						menu === "notes" && "bg-primary text-white",
					)}
					onClick={() => setMenu("notes")}
				>
					{t("notes")}
				</Button>
			)}

			{canViewWorkingShift && (
				<Button
					className={classNames(
						"text-primary px-3 p-2 btn-round mb-2 mb-md-2 shadow-lg mx-1 small-radius border ",
						menu === "working-shifts" && "bg-primary text-white",
					)}
					onClick={() => setMenu("working-shifts")}
				>
					{t("working-shifts")}
				</Button>
			)}

			<Button
				className={classNames(
					"text-primary px-3 p-2 btn-round mb-2 mb-md-2 shadow-lg mx-1 small-radius border ",
					menu === "settings" && "bg-primary text-white",
				)}
				onClick={() => setMenu("settings")}
			>
				{t("settings")}
			</Button>

			{canViewHistory && (
				<Button
					className={classNames(
						"text-primary px-3 p-2 btn-round mb-2 mb-md-2 shadow-lg mx-1 small-radius border ",
						menu === "history" && "bg-primary text-white",
					)}
					onClick={() => setMenu("history")}
				>
					{t("history")}
				</Button>
			)}
		</div>
	);
}

export default Topbar;
